var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnChatbot01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7539 42.2473C46.7105 41.9309 46.7961 41.6111 46.9848 41.3536C50.138 37.0511 52 31.7431 52 26.0001C52 11.6407 40.3594 0.000106812 26 0.000106812C11.6406 0.000106812 0 11.6407 0 26.0001C0 40.3595 11.6406 52.0001 26 52.0001C30.4995 52.0001 34.7321 50.8571 38.4233 48.8457C38.72 48.684 39.0697 48.6464 39.3911 48.7505L46.2117 50.9587C47.0533 51.2312 47.8904 50.5303 47.7701 49.6539L46.7539 42.2473Z",
    fill: "#003F9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnChatbot01);
export default __webpack_public_path__ + "static/media/btn_chatbot_01.e7e39e538547f1fb0b9bfaa10131b8c3.svg";
export { ForwardRef as ReactComponent };